import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FORMNAMES } from "../utilities/codes";
import { getFormEntriesByFormName } from "../services/formServices";
import { schoolContext } from "../contexts/SchoolContextProvider"
import AboutSchool from "../components/AboutSchool";
import { useTranslation } from "react-i18next";
import { useBackgroundImage } from "../utilities/mediautilities.js";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const About = () => {
    const { schoolDetails } = useContext(schoolContext);
    const [features, setFeatures] = useState([]);
    const { t } = useTranslation();

    const bgUrl = useBackgroundImage(schoolDetails?.about_us?.fileUrl);
    useEffect(() => {
        getFeatures();
    }, []);

    const getFeatures = async () => {
        try {
            const response = await getFormEntriesByFormName(FORMNAMES.SCHOOLFEATURES);
            setFeatures(response);
        } catch (error) {
            toast.error(error.message);
        }
    }
    const featureVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, type: "spring", stiffness: 120 },
        }),
    };

    return (
        <>
            <section
                className="relative bg-cover bg-center py-20 px-6"
                style={{ backgroundImage: `url(${bgUrl})` }}
            >
                <div className="absolute inset-0 bg-black/50"></div>
                <div className="relative z-10 common-container">
                    <div className="rounded-lg text-left">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-accent">
                            {t(I18N_KEYS.ABOUTPAGENAME)}
                        </h1>
                        <p className="text-lg md:text-xl text-accent">
                            <Link to="/" className="hover:text-primary transition-colors">
                                {t(I18N_KEYS.HOMEPAGENAME)}
                            </Link>{" "}
                            &gt; {t(I18N_KEYS.ABOUTPAGENAME)}
                        </p>
                    </div>
                </div>
            </section>

            <AboutSchool />

            {features?.length > 0 &&
                <section className="bg-gray-100 py-20 px-6 overflow-hidden">
                    <div className="common-container">
                        <h2 className="text-4xl font-bold text-center text-primary mb-12">
                            {t(I18N_KEYS.FEATURETITLE)}
                        </h2>
                        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    custom={index}
                                    variants={featureVariants}
                                    initial="hidden"
                                    whileInView="visible"
                                    whileHover={{ scale: 1.08 }}
                                    className="relative bg-gradient-to-tr from-accent to-gray-100 p-6 rounded-2xl shadow-lg cursor-pointer hover:shadow-2xl transition-transform duration-500 overflow-hidden"
                                >
                                    {(feature?.payload?.feature_title || feature?.payload?.description) &&
                                        <div className="mt-8">
                                            {feature?.payload?.feature_title &&
                                                <h3 className="text-xl font-bold text-primary mb-3">{feature?.payload?.feature_title}</h3>
                                            }
                                            {feature?.payload?.description &&
                                                <p className="text-gray-600"
                                                    dangerouslySetInnerHTML={{
                                                        __html: feature?.payload?.description
                                                    }}
                                                ></p>
                                            }
                                        </div>
                                    }

                                    <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-primary/10 blur-2xl"></div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            }


        </>
    );
}

export default About;